export default __webpack_public_path__ + "static/media/page-not-found.1d123312.png";